






























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import ScrollToBottomVue from "@/components/ScrollToBottom.vue";

@Component({
    components: {
        "scroll-to-bottom": ScrollToBottomVue
    }
})
export default class AddUser extends Vue {
    @Prop({ type: Object })
    userData!: Account | null;

    name: string | null = null;
    loginId: string | null = null;
    selfPhone: string | null = null;
    phone: string | null = null;

    nameTip: boolean = false;
    loginIdTip: boolean = false;
    leaderTip: boolean = false;
    areaTip: boolean = false;
    joinTime: Date | "" = new Date();
    timeTip: boolean = false;

    //角色选择
    leaderVal: Account | string | null = null;
    leaders: Account[] = [];
    leadLoad: boolean = false;
    leaderNo: string | null = null;
    query: string = "";
    page: number = 1;
    pageSize: number = 20;
    totalPages: number = 0;
    //区域选择
    areaVal: string = "";
    areas: string[] = [];

    //员工角色
    roleVal: string = "";
    roleTip: boolean = false;
    hasChanged: boolean = false;

    partyId: string = "";
    partyName: string = "";
    isAdd: boolean = false;

    get roles() {
        if (+this.$store.state.account.level === 1) {
            return ["会计", "助理", "主管", "经理", "管理员"]
        } else {
            return ["会计", "助理", "主管", "经理"]
        }
    }

    get canEdit() {
        if (this.$store.state.account.role != "会计" && this.$store.state.account.role != "助理") {
            return true
        } else {
            return false
        }
    }

    mounted() {
        this.getLeaders();
        this.getAreas();
        if (this.userData != null) {
            this.initData(this.userData);
            this.isAdd = false;
        }
        else {
            this.isAdd = true;
        }
    }

    @Watch("name")
    nameChange(val: string) {
        this.hasChanged = true;
        if (val != null) {
            this.nameTip = false
        }
    }
    @Watch("loginId")
    loginIdChange(val: string) {
        if (val != null) {
            this.loginIdTip = false
        }
    }
    @Watch("leaderVal")
    leaderValChange(val: string) {
        this.hasChanged = true;
        if (val != null)
            this.changeLeader(val);
        this.leaderTip = false
    }
    @Watch("areaVal")
    areaValChange(val: string) {
        if (val != "") {
            this.areaTip = false
        }
    }
    @Watch("roleVal")
    roleValChange(val: string) {
        this.hasChanged = true;
        if (val != "") {
            this.roleTip = false
        }
    }
    @Watch("joinTime")
    joinTimeChange(val: Date | string) {
        if (val != "" && val != undefined) {
            this.timeTip = false
        } else {
            this.timeTip = true
        }
    }

    //初始化shuju
    initData(val: Account) {
        if (val != null) {
            this.getAreas();
            this.name = (<string>val.name);
            this.loginId = (<string>val.loginId);
            this.selfPhone = (<string>val.selfPhone);
            this.phone = (<string>val.phone);
            this.areaVal = (<string>val.area);
            this.leaderVal = (<string>val.pname);
            this.leaderNo = (<string>val.pno);
            this.roleVal = (<string>val.role);
            this.partyId = (<string>val.partyId);
            this.partyName = (<string>val.partyName);
            if (val.joinTime == "" || val.joinTime == null)
                this.joinTime = new Date();
            else
                this.joinTime = new Date(val.joinTime)
        }
    }

    leadFn(query: string, cb?: Function) {
        Vue.axios.post("accounts/find?page=" + (this.page - 1) + "&size=" +
            this.pageSize, {
                query: query,
                accounterNo: this.$store.state.account.no,
            }).then(response => {
                this.totalPages = response.data.totalPages;
                if (cb) cb(response);
            })
    }

    remoteMethod(query: string) {
        this.query = query;
        this.leadLoad = true;
        this.page = 0;
        this.leaders = [];
        this.leadFn(query, (response: AxiosResponse) => {
            this.leadLoad = false;
            this.leaders = response.data.content;
        })
        if (query == "") {
            this.page = 0;
            this.leaderVal = null;
            this.leaderNo = null;
        }
    }

    //获取上级
    getLeaders() {
        // this.leaders = [];
        this.leadFn(this.query, (response: AxiosResponse) => {
            for (let i = 0; i < response.data.content.length; i++) {
                this.leaders.push(response.data.content[i])
            }
        })
    }

    changeLeader(val: Account | string) {
        if (typeof val != "string") {
            this.hasChanged = true;
            this.leaderNo = val.no;
        }
    }

    //获取所有区域
    getAreas() {
        Vue.axios.get(`regions/find`).then(res => {
            this.areas = res.data;
        });
    }

    showTip(v: string, val: string) {
        // @ts-ignore
        if (this[v] == null || this[v] == "") {
            // @ts-ignore
            this[val] = true
        } else {
            // @ts-ignore
            this[val] = false
        }
    }

    resetForm() {
        this.name = null;
        this.nameTip = false;
        this.loginId = null;
        this.loginIdTip = false;
        this.selfPhone = null;
        this.phone = null;
        this.leaderVal = null;
        this.leaderNo = null;
        this.leaderTip = false;
        this.areaVal = "";
        this.areaTip = false;
        this.roleVal = "";
        this.roleTip = false;
        this.hasChanged = false;
        this.partyId = "";
        this.partyName = "";
    }

    confirmUser() {
        if (this.name === null || this.name === "") {
            this.nameTip = true;
        } else if (this.loginId === null || this.loginId === "") {
            this.loginIdTip = true;
        } else if (this.leaderNo === null) {
            this.leaderTip = true;
        } else if (this.areaVal === "") {
            this.areaTip = true;
        } else if (this.joinTime === "") {
            this.timeTip = true;
        } else if (this.roleVal === "" || this.roleVal === null) {
            this.roleTip = true;
        } else {
            let id = null,
                no = null,
                leaf = null,
                pwd = null;
            if (this.userData != null) {
                id = this.userData.id;
                no = this.userData.no;
                leaf = this.userData.leaf;
                pwd = this.userData.hashPassword;
            }
            Vue.axios.post("accounts/saveorupdate", {
                id: id,
                name: this.name,
                loginId: this.loginId,
                selfPhone: this.selfPhone,
                phone: this.phone,
                no: no,
                pno: this.leaderNo,
                area: this.areaVal,
                role: this.roleVal,
                joinTime: this.$utils.simpleDateFormat(this.joinTime, "d", true),
                partyId: this.partyId,
                partyName: this.partyName,
                leaf: leaf,
                hashPassword: pwd
            }).then(response => {
                this.$emit("close", true, this.hasChanged);
            })
        }
    }
    //关闭modal
    closeAddUser() {
        this.$emit("close", false);
    }
}
